import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import ItemImageTextStandard from '~/components/cms/custom/ItemImageText/ItemImageTextStandard.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ItemImageText',
  props: {
    title: null,
    items: {
      default: function _default() {
        return [];
      }
    },
    displayOptions: {
      default: function _default() {
        return [];
      }
    },
    image: null,
    text: null,
    componentName: null,
    isPhased: {
      type: Boolean
    },
    isInEnum: {
      type: Boolean
    },
    topContent: null,
    bottomContent: null,
    isHomePage: {
      type: Boolean
    },
    isInExpandableTab: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var ItemImageTextPhased = function ItemImageTextPhased() {
      return import('~/components/cms/custom/ItemImageText/ItemImageTextPhased.vue');
    };
    var ItemImageTextEnum = function ItemImageTextEnum() {
      return import('~/components/cms/custom/ItemImageText/ItemImageTextEnum.vue');
    };
    var ItemImageTextTwo = function ItemImageTextTwo() {
      return import('~/components/cms/custom/ItemImageText/ItemImageTextTwo.vue');
    };
    var componentParsedName = computed(function () {
      if (props.isPhased) {
        return ItemImageTextPhased;
      }
      if (props.isInEnum) {
        return ItemImageTextEnum;
      }
      switch (props.componentName) {
        case 'ItemImageText':
          return ItemImageTextStandard;
        case 'ItemTwoTextImageList':
          return ItemImageTextTwo;
        default:
          return ItemImageTextStandard;
      }
    });
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      __sfc: true,
      ItemImageTextPhased: ItemImageTextPhased,
      ItemImageTextEnum: ItemImageTextEnum,
      ItemImageTextTwo: ItemImageTextTwo,
      props: props,
      componentParsedName: componentParsedName,
      classes: classes
    };
  }
});